/**
 * Cluster header rectangles (flow coordinates), provided by the board and read
 * by the custom edge so it can ghost the part of a highlighted arrow that
 * crosses a cluster header to 30% opacity when a CLUSTER is selected.
 *
 * Headers sit ABOVE the node cards in z (header < card), so "above the cards
 * but behind the header" is impossible to express with z-index alone — the edge
 * uses an opacity mask keyed to these rectangles instead. See ResearchEdge.
 */

import { createContext } from 'react';

export interface HeaderRect {
  /** Flow-coordinate top-left + size of the cluster header strip. */
  x: number;
  y: number;
  width: number;
  height: number;
}

export const ClusterHeaderRectsContext = createContext<HeaderRect[]>([]);
